import { Selector, State } from "./types";

function createSelector(getState: () => State): Selector {
  return {
    isRequestExportBiRunRequestFailure() {
      return getState().isFailure;
    },
    isRequestExportBiRunRequestPending() {
      return getState().isPending;
    },
    isRequestExportBiRunRequestSuccess() {
      return getState().isSuccessful;
    },
  };
}

export { createSelector };
